// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P8OaM","label":"styles_label__ndCs3"};